module.exports = __webpack_public_path__ + "img/fr.fec56e11.png";